import {
  colors,
  ImpButton,
  ImpButtonDock,
  ImpButtonProps,
  ImpContainer,
  ImpFlex,
  ImpSpacer,
} from '@imprint-payments/imprint-ui';
import { ReactNode } from 'react';

import { FORM_BUTTON_WIDTH } from '../../assets/consts/const';

interface OnboardingLayoutProps {
  children: ReactNode;
  bottomButtons?: ImpButtonProps[];
}

export default function OnboardingLayout({
  children,
  bottomButtons,
}: OnboardingLayoutProps) {
  return (
    <ImpContainer
      backgroundColor={colors.surface.surfaceMid}
      width="100%"
      height="100%"
    >
      <ImpFlex
        fluid
        direction="column"
        align="center"
        mobileJustify="space-between"
      >
        <ImpContainer width={FORM_BUTTON_WIDTH} textAlign="center">
          <ImpFlex direction="column" align="center" fluid>
            {children}
            <ImpSpacer height="xl" />
          </ImpFlex>
        </ImpContainer>
        {bottomButtons && bottomButtons.length > 0 && (
          <ImpFlex direction="column" align="center">
            <ImpButtonDock alwaysColumn>
              {bottomButtons.map((buttonProps, index) => (
                <ImpButton key={index} {...buttonProps} />
              ))}
            </ImpButtonDock>
            <ImpSpacer height="s" />
          </ImpFlex>
        )}
      </ImpFlex>
    </ImpContainer>
  );
}
